import { useCallback, useEffect, useState } from 'react';
import Prompt from 'components/Prompt';

type UsePreventReloadReturn = {
  PromptComponent: JSX.Element;
  disablePrompt: () => void;
  enablePrompt: () => void;
};

export const usePreventReload = (
  isPrevent: boolean,
  message: string = 'Are you sure you want to leave this page? Changes will not be saved',
): UsePreventReloadReturn => {
  const [isPrompt, setIsPrompt] = useState(isPrevent);

  const preventUnload = useCallback(
    (event: BeforeUnloadEvent) => {
      event.preventDefault();
      return message;
    },
    [message],
  );

  useEffect(() => {
    setIsPrompt(isPrevent);
  }, [isPrevent]);

  useEffect(() => {
    if (isPrompt) {
      window.addEventListener('beforeunload', preventUnload);
    } else {
      window.removeEventListener('beforeunload', preventUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', preventUnload);
    };
  }, [isPrompt, preventUnload]);

  const disablePrompt = useCallback(() => {
    setIsPrompt(false);
  }, []);

  const enablePrompt = useCallback(() => {
    setIsPrompt(true);
  }, []);

  return {
    PromptComponent: <Prompt when={isPrompt} message={message} />,
    disablePrompt,
    enablePrompt,
  };
};
